import React from 'react';
import { Heading, Box, Center } from '@chakra-ui/react';

import { useGuest } from '@/context/guest';
import useInvitation from '@/hooks/useInvitation';
import useLang from '@/hooks/useLang';

import WithAnimation from '@/components/Common/WithAnimation';
import AddToCalendarButton from '@/components/Common/AddToCalendar';
import CountDown from '@/components/Common/CountDown';
import QRCard from '@/components/Common/QRCard/V3';
import WeddingDetail from './WeddingDetail';

import {
  WEDDING_AKAD_FULLDATE,
  WEDDING_AKAD_LOC_NAME,
  WEDDING_AKAD_TIME,
  WEDDING_AKAD_LOC_ROAD,
  WEDDING_AKAD_DRESSCODE,
  WEDDING_AKAD_NOTE,
  WEDDING_RESEPSI_FULLDATE,
  WEDDING_RESEPSI_LOC_NAME,
  WEDDING_RESEPSI_LOC_ROAD,
  WEDDING_RESEPSI_DRESSCODE,
  WEDDING_RESEPSI_NOTE,
  GOOGLE_MAPS_LINK,
} from '@/constants';

import { ID_COUNTDOWN_SECTION, ID_QRCODE } from '@/constants/identifier';
import { ENABLE_QR_INVITATION, MUSLIM_INVITATION } from '@/constants/feature-flags';

import generateShift from '@/hooks/useShift';
import { RSVP_STATUS } from '@/constants/api';
import { TEXT_PROPS } from '@/constants/default-props';
import txtWording from './locales';

function WeddingSection({ ...rest }) {
  const lang = useLang();
  const isInvitation = useInvitation();
  const { guest } = useGuest();

  const { code, status, is_group_link } = guest;
  const shiftTime = generateShift(guest.shift);

  return (
    <>
      <Box padding="12px 0 0px 0" bgColor="bgPrimary" {...rest}>
        <WithAnimation>
          <Heading
            {...TEXT_PROPS.subHeading}
            color="mainColorText"
            marginBottom="42px"
            paddingLeft="0px"
            textAlign="center"
          >
            {txtWording.title[lang]}
          </Heading>
        </WithAnimation>
        {/* Wedding info section */}
        <Box padding="0 28px" marginTop="-16px">
          <WithAnimation>
            <WeddingDetail
              date={WEDDING_AKAD_FULLDATE[lang]}
              time={WEDDING_AKAD_TIME}
              title={MUSLIM_INVITATION ? txtWording.akadMuslim[lang] : txtWording.akadGeneral[lang]}
              subTitle={
                isInvitation && (
                  <>
                    <span>{WEDDING_AKAD_LOC_NAME}</span>
                    <br />
                    <span>
                      <i>{WEDDING_AKAD_LOC_ROAD}</i>
                    </span>
                  </>
                )
              }
              dresscode={isInvitation ? WEDDING_AKAD_DRESSCODE : ''}
              note={isInvitation ? WEDDING_AKAD_NOTE : ''}
              //location={GOOGLE_MAPS_LINK}
            />
          </WithAnimation>
          {isInvitation && (
            <WithAnimation>
              <WeddingDetail
                date={WEDDING_RESEPSI_FULLDATE[lang]}
                time={shiftTime}
                title={txtWording.reception[lang]}
                subTitle={
                  <>
                    <span>{WEDDING_RESEPSI_LOC_NAME}</span>
                    <br />
                    <span>
                      <i>{WEDDING_RESEPSI_LOC_ROAD}</i>
                    </span>
                  </>
                }
                location={GOOGLE_MAPS_LINK}
                dresscode={WEDDING_RESEPSI_DRESSCODE}
                note={WEDDING_RESEPSI_NOTE}
              />
            </WithAnimation>
          )}

          {code && ENABLE_QR_INVITATION && status !== RSVP_STATUS.notAttend && !is_group_link && (
            <WithAnimation>
              <Center name={ID_QRCODE}>
                <QRCard isDirectLink={true} />
              </Center>
            </WithAnimation>
          )}
        </Box>
        <WithAnimation>
          <Heading
            {...TEXT_PROPS.subHeading}
            color="mainColorText"
            paddingLeft="0px"
            margin="52px 0 26px 0"
            name={ID_COUNTDOWN_SECTION}
          >
            COUNTDOWN
          </Heading>
        </WithAnimation>

        <Box width="100%" bgColor="bgSecondary" padding="12px 0 32px 0" color="secondaryColorText">
          <WithAnimation>
            <Center>
              <CountDown lang="en" />
            </Center>
          </WithAnimation>
          {isInvitation && (
            <WithAnimation>
              <Center>
                <AddToCalendarButton
                  {...TEXT_PROPS.body}
                  fontWeight="700"
                  marginTop="16px"
                  size="sm"
                  text={txtWording.calendar[lang]}
                  variant="ghost"
                  fontSize="md"
                  colorScheme="blackAlpha"
                  color="mainColorTextLight"
                  bgColor="bgAlternative"
                />
              </Center>
            </WithAnimation>
          )}
        </Box>
      </Box>
    </>
  );
}

export default React.memo(WeddingSection);
